<div class="app-wrapper h-screen">
  <p-toast />
  <!-- topbar -->
  <app-topbar></app-topbar>
  <!-- topnav-->

  <div class="content-page min-h-screen">
    <div class="content">
      <!-- content -->
      <div class="px-2 py-2 md:px-4 lg:px-6">
        <router-outlet></router-outlet>
      </div>
    </div>
    <!-- footer -->
    <app-footer></app-footer>
  </div>
</div>